import { app } from '../../../../app';
import { Controller } from './administrators-list.controller';

app.component('companyAdministratorsList', {
    bindings: {
        account: '<',
        administrators: '<',
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./administrators-list.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/administrators/list/administrators-list.component.js